// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_3EWv","Header__container":"Header__container_3s6s","Header__containerBig":"Header__containerBig_rXcq","Header__flag":"Header__flag_3Zge","Brand":"Brand_15XJ"};